"use strict";

import angular from "angular";

import template from "./need-help.component.html";
import "./need-help.component.scss";

class NeedHelpComponent {
    constructor(ChatAtendimentoService) {
        this.ChatAtendimentoService = ChatAtendimentoService;
    }

    $onInit() {}

    onOpenChat() {
        this.ChatAtendimentoService.open();
    }
}

NeedHelpComponent.$inject = ["ChatAtendimentoService"];

const component = {
    controller: NeedHelpComponent,
    bindings: {}
};

const name = "needHelpComponent";
const def = {
    ...component,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
